import { useQuery } from '@tanstack/react-query';

import {
  getDistributionById,
  type GetDistributionByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';
import type { QueryOptions } from '@/types/react-query';

export default function useDistribution(
  id: string,
  options?: QueryOptions<GetDistributionByIdResponse>,
) {
  return useQuery({
    queryKey: queryKeys.distributions.detail(id),
    queryFn: () =>
      getDistributionById({ path: { distribution_id: id } }, wgApi),
    ...options,
  });
}
